module.exports = __webpack_public_path__ + "gw.47fd8d67.svg";